import {createContext} from 'react';
const CurrencyContext= createContext({currency:[],exchangeCurrencyRes:[],currenciesLst:[]})


export default CurrencyContext;